import { List } from 'components/list';
import { formatPrice } from 'utils/helpers';
import { formatCalendarDate } from 'utils/date';
import { ListCard } from 'components/list-card';
import { ListHeader } from 'components/list-header';
import { EventPayment } from 'store/api/event/types';
import {
  eventPaymentTypeLabel,
  eventPaymentTransactionLabel,
} from 'store/api/event';

export const EventPayments = ({ payments }: { payments: EventPayment[] }) => {
  return (
    <List
      count={payments?.length}
      header={
        <ListHeader
          titles={[
            'Payment Type',
            'Transaction',
            'Notes',
            'Amount',
            'Date',
            'Paid/Scheduled By',
            'Payment Method',
            'Cashed',
          ]}
        />
      }
    >
      {payments?.map((payment) => (
        <ListCard
          key={payment.id}
          values={[
            eventPaymentTypeLabel[payment.type],
            payment.transaction &&
              eventPaymentTransactionLabel[payment.transaction],
            payment.notes,
            payment.amount === null || payment.amount === undefined
              ? undefined
              : formatPrice(payment.amount),
            // The saved day in every timezone (stored as the saving
            // browser's local midnight, e.g. 03:00Z).
            payment.date && formatCalendarDate(payment.date),
            payment.paidBy?.name,
            payment.paymentMethod?.name,
            payment.cashed ? 'Yes' : 'No',
          ]}
        />
      ))}
    </List>
  );
};
